import React, { useState, useEffect } from "react";
import { Container, Slider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { P1, P2, P3 } from "assets/fonts";
import axios from "axios";
import { useDispatch } from "react-redux";
import { addMandatoryComponent } from "redux/mandatory-components/mandatoryCom-reducer";

const useStyles = makeStyles({
  slider: {
    width: "100%",
    color: "#3f51b5",
  },
});

const SliderV2 = (props) => {
  const classes = useStyles();
  const { id, updateAssign, readyToContinue } = props;
  const [question, setQuestion] = useState("");
  const [options, setOptions] = useState([]);
  const [answer, setAnswer] = useState(null);
  const [optional, setOptional] = useState(false);
  const [maxValue, setMaxValue] = useState(100);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(addMandatoryComponent(id));
  }, []);

  useEffect(() => {
    if (id) {
      (async () => {
        const doc = await axios.get("/api/gui/sliderv2/" + id);
        setQuestion(doc.data.question);
        setOptions(doc.data.options);
        setOptional(doc.data.optional ?? false);
        setMaxValue(doc.data.maxValue ?? 100);
      })();
    }
  }, [id]);

  useEffect(() => {
    if (optional) {
      handleUpdateAssign();
      readyToContinue(id);
    }
  }, [optional]);

  useEffect(() => {
    handleUpdateAssign();
    if (!!answer) {
      readyToContinue(id);
    }
  }, [answer]);

  const handleUpdateAssign = () => {
    const assign = {
      id,
      type: "sliderv2",
      question,
      options,
      maxValue,
      answer,
    };
    updateAssign(assign);
  };

  const handleSliderChange = (event, newValue) => {
    setAnswer(newValue);
  };

  return (
    <Container>
      <br />
      <P2 style={{ fontWeight: "300" }}>{question}</P2>
      <br />
      <div className="row">
        <div className="col-2">
          <P3 style={{ fontWeight: "300" }}>{options[0]}</P3>
        </div>
        <div className="col-8">
          <Slider
            className={classes.slider}
            value={answer || 0}
            onChange={handleSliderChange}
            aria-labelledby="continuous-slider"
            min={0}
            max={maxValue}
            valueLabelDisplay="auto"
          />
        </div>
        <div className="col-2">
          <P3 style={{ fontWeight: "300" }}>{options[1]}</P3>
        </div>
      </div>
      <br />
    </Container>
  );
};

export default SliderV2;
